<template>
  <div class="StickyBox" id="box">
    <section class="sticky-container" refs="box">
      <div ref="stickyContainer" class="sticky-image">
        <ul class="font-box" ref="fontBox">
          <li v-for="(item, index) in fontList" :key="index" v-html="item" ref="font" :class="{'active': active == index }" ></li>
        </ul>
        <img class="big-image" src="../assets/family/kangxin/kangxinsticky.png" alt="">
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "StickyBox",
  components: {},
  data() {
    return {
      fontList: [
        `<span>1</span><span>5</span>细料组合压贴层`,
        `提高板材表面平整度`,
        `<span>2</span><span>3</span><span>4</span>纵横交错中创片层`,
        `1.增强板材结合强度`,
        `2.增强板材静曲强度`,
        `3.增强板材稳定性能`
      ],
      scrollCount: 0,
      active: 0,
      stickyTop: 0
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    window.addEventListener('scroll', () => {
      const box = document.getElementById('box').scrollTop
      console.log('box', box)
      const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
      console.log('scrollTop', scrollTop, 'scrollHeight', scrollHeight, 'clientHeight', clientHeight, 'stickyContainer', this.$refs.stickyContainer.offsetTop)
      const headerHeight = Math.round(document.querySelector('.header').offsetHeight)
      // console.log('--------', this.$refs.stickyContainer.offsetTop)
      // console.log('scrollTop', scrollTop)
      // const scrolled = scrollTop / (scrollHeight - clientHeight);
      console.log(222, Math.ceil(scrollTop - this.$refs.stickyContainer.offsetTop)) 
      if (Math.abs(Math.ceil(scrollTop - this.$refs.stickyContainer.offsetTop)) == Math.abs(headerHeight)) {
        console.log(this.scrollCount) 
        // console.log(123, 'scrollTop', scrollTop, scrollHeight - clientHeight)
        // console.log('if scrolled', scrolled)
        const scroll = scrollTop / (scrollHeight - clientHeight)
        // console.log('scroll', scroll)
        this.$refs.font.map(item => {
          item.style.opacity = 1
          item.style.transform = `translate(${scroll}px, 0px)`
        })
      } else {
        this.$refs.font.map(item => {
          item.style.opacity = 0
        })
      }
      // const scrolled = scrollTop / (scrollHeight - clientHeight);
      // const headerHeight = Math.round(document.querySelector('.header').offsetHeight)
      // console.log(this.$refs.stickyContainer.offsetTop)
      // console.log('stickyTop', this.stickyTop)
      // console.log('scrolled', headerHeight, scrolled)
      // if (containerTop <= headerHeight && containerTop >= headerHeight -1  ) {
      //   this.$refs.fontBox.style.top = `${this.stickyTop - (windowTop + headerHeight) }px`
      //   let topNum = Math.abs(Math.round(this.$refs.fontBox.style.top.replace(/px/, '') / 100))
      //   this.$refs.font.forEach((item, index) => {
      //     if (this.active <= topNum && this.active < this.$refs.font.length) {
      //       this.active =  topNum
      //       this.$refs.font[this.active].style.opacity = 1
      //       this.active - 1  >= 0 ? this.$refs.font[this.active - 1].style.opacity = (this.stickyTop - (windowTop + headerHeight))*0.001 : ''
      //       this.active + 1  >= 0 ? this.$refs.font[this.active + 1].style.opacity = 0 : ''
      //     } else if (this.active > topNum) {
      //       this.active = topNum
      //       this.active >= 0 ? this.$refs.font[this.active].style.opacity =  1 - (this.stickyTop - (windowTop + headerHeight))*0.003 : ''
      //       this.active + 1  >= 0 ? this.$refs.font[this.active + 1].style.opacity = (this.stickyTop - (windowTop + headerHeight))*0.001 : ''
      //     } else {
      //       this.$refs.font[index].style.opacity = 0
      //     }
      //   })
      // }
    }, false)
  },
  methods: {},
};
</script>
<style lang='less' scoped>
.StickyBox{
  width: 1498px;
  margin: 0 auto;
  -webkit-user-select: none;
}
.sticky-container {
  height: 200vh;
}
.sticky-image{
  height: 100vh;
  background: #fff;
  top: 112px;
  z-index: 1;
  position: sticky;
  .font-box {
    width: 1007px;
    top: 0px;
    left: 50%;
    margin-top: 160px;
    margin-left: -503.5px;
    position: absolute;
    li {
      width: 100%;
      height: 100px;
      list-style: none;
      font-size: 24px;
      font-family: FZLanTingHeiS-R-GB;
      font-weight: 400;
      color: #666666;
      line-height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      text-align: center;
      /deep/ span {
        width: 40px;
        background: #666;
        color: #fff;
        border-radius: 50%;
        margin-right: 10px;
      }
      &.active {
        opacity: 1;
        /deep/ span {
          background: #986F40;
        }
      }
    }
  }
  .big-image {
    width: 100%;
    position: absolute;
    bottom: 112px;
    left: 0;
  }
}
</style>